export default __webpack_public_path__ + "static/rpa-marketing-e552ee2822a4639cdecedb89814c38a0.png";